var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@emotion/styled";
export var TurnControl = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t/* Start just right of the anchor (the handle's right-hand edge), centred\n\t * on it vertically. */\n\ttransform: translate(0.5rem, -50%);\n"], ["\n\t/* Start just right of the anchor (the handle's right-hand edge), centred\n\t * on it vertically. */\n\ttransform: translate(0.5rem, -50%);\n"])));
var templateObject_1;
